export default __webpack_public_path__ + "static/media/guar.7be6f626.png";